import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Spinner,
} from "reactstrap";
import {
  perPageEntries,
  addSearch,
  decresePage,
  incresePage,
  reqRegData,
  setZero,
  clearError,
  userId,
  searchCondi,
  userStatus,
} from "../../store/data/actions";

const UnsubscribeUser = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const search = useSelector((state) => state.UserData.search);
  const perPage = useSelector((state) => state.UserData.perPage);
  const page = useSelector((state) => state.UserData.page);
  const error = useSelector((state) => state.UserData.error);
  const registredData = useSelector((state) => state.UserData.registeredUser);
  const searchToggle = useSelector((state) => state.UserData.searchCondi);
  const limit = useSelector(
    (state) => state.UserData.registeredUser?.data?.limit
  );
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => {
    if (data.search !== search) {
      dispatch(searchCondi(true));
      dispatch(addSearch(data.search));
    }
  };
  const lastPage = useSelector(
    (state) => state.UserData.registeredUser?.data?.last_page
  );
  const currentPage = useSelector(
    (state) => state.UserData.registeredUser?.data?.current_page
  );
  const userDatas = useSelector(
    (state) => state.UserData.registeredUser?.data?.data
  );
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  useEffect(() => {
    dispatch(searchCondi(true));
    dispatch(
      reqRegData({
        page: page,
        registered_with: "",
        search: search,
        limit: perPage,
        unsubscribe: 1,
      })
    );
    if (currentPage > lastPage) {
      dispatch(setZero());
    }
  }, [dispatch, page, search, perPage, currentPage, lastPage]);

  const errorHandle = () => {
    alert(error?.message);
    dispatch(clearError());
  };

  const UserDetails = async (id) => {
    dispatch(userId(id));
    history.push(`/user-details/${id}`);
  };

  const handleActive = (id) => {
    dispatch(userStatus(id));
    dispatch(
      reqRegData({
        page: page,
        registered_with: "",
        search: search,
        limit: perPage,
        unsubscribe: 1,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row className="align-items-center m-3">
          <Col>
            <Row className="align-items-center">
              <Button
                disabled={page <= 1}
                onClick={() => dispatch(decresePage(1))}
              >
                Prev.
              </Button>
              <h6 className="ml-4 mr-4">{currentPage}</h6>
              <Button
                disabled={page >= lastPage}
                onClick={() => dispatch(incresePage(1))}
              >
                Next
              </Button>
              <h6 className="ml-4 mr-4">Total Pages: {lastPage}</h6>
            </Row>
          </Col>
          <Col>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret>Per Page - {perPage}</DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => dispatch(perPageEntries(5))}>
                  5
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(10))}>
                  10
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(20))}>
                  20
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(50))}>
                  50
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(100))}>
                  100
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(200))}>
                  200
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
          <Col>
            <form
              className="float-right d-md-flex"
              onSubmit={handleSubmit(onSubmit)}
            >
              <input
                className="form-control"
                type="text"
                {...register("search")}
                defaultValue={search}
                placeholder="search"
              />
              <Button className="ml-2" color="info" outline type="submit">
                Search
              </Button>
            </form>
          </Col>
        </Row>
        {((!registredData && !error) ||
          currentPage !== page ||
          perPage !== limit ||
          searchToggle) && <Spinner color="dark" />}
        {error && errorHandle()}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Unsubscribers List</h4>
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive mb-0"
                    data-pattern="priority-columns"
                  >
                    <table
                      id="tech-companies-1"
                      className="table table-striped"
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>User Name</th>
                          <th>Email</th>
                          <th>Social Platform</th>
                          <th>Registered</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {registredData && !error && (
                        <tbody>
                          {currentPage === page &&
                            perPage === limit &&
                            !searchToggle &&
                            userDatas?.map((userData) => (
                              <tr key={userData.id}>
                                <th>{userData.id || "--"}</th>
                                <th>{userData.username || "--"}</th>
                                <th>{userData.email || "--"}</th>
                                <th>{userData.social_platform || "--"}</th>
                                <th>{userData.user_registered || "--"}</th>
                                <th>
                                  <Button
                                    color={
                                      userData.user_status === "yes" ||
                                      userData.user_status === "active"
                                        ? "success"
                                        : "danger"
                                    }
                                    outline
                                    onClick={() => handleActive(userData.id)}
                                  >
                                    {userData.user_status === "yes" ||
                                    userData.user_status === "active"
                                      ? "Active"
                                      : "Deactive"}
                                  </Button>
                                </th>
                                <th>
                                  <Button
                                    color="primary"
                                    outline
                                    onClick={() => UserDetails(userData.id)}
                                  >
                                    <i className="ti-user"></i>
                                  </Button>
                                </th>
                              </tr>
                            ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UnsubscribeUser;
